import { VExtensionData, VExtensionDevice } from '../views/account';


export interface IAccount {
  companyName: string;
  branchName: string;
  postalCode: string;
  prefCode: number;
  prefecture: string;
  address: string;
  building: string;
  mail: string;
  billingMail: string;
  tel: string;
  uninstallPass: string;
  contract: string;
  payment: number;
  quit: number;
  monthClientCount: number;
  registrationPeriodStart: string;
  trialDeadline: string;
  isDelayByBank: boolean;
  isDelayByCredit: boolean;
  token: string;
  isExtension: boolean;
  isExtensionDays: number;
  isExtensionEnd: string;
  diffDay: number;
  nowMonthMM: number;
  nowMonthMMDD: string;
  freePeriodLastDate: string;
  registrationPeriodStartDate: string;
  nextMonth: number;
  invoicePeriods: number[];
  createdAt: Date;
  currentExtensionYear: number;
  currentExtensionPeriod: string;
  extensionData: VExtensionData;
  deviceList: VExtensionDevice[];
}


export class CAccount implements IAccount {
  public companyName = '';
  public branchName = '';
  public postalCode = '';
  public prefCode = 0;
  public prefecture = '';
  public address = '';
  public building = '';
  public mail = '';
  public billingMail = '';
  public tel = '';
  public uninstallPass = '';
  public contract = '';
  public payment = 0;
  public quit = 0;
  public monthClientCount = 0;
  public registrationPeriodStart = '';
  public trialDeadline = '';
  public isDelayByBank = false;
  public isDelayByCredit = false;
  public token = '';
  public isExtension = false;
  public isExtensionDays = 0;
  public isExtensionEnd = '';
  public diffDay = 0;
  public nowMonthMM = 0;
  public nowMonthMMDD = '';
  public freePeriodLastDate = '';
  public registrationPeriodStartDate = '';
  public nextMonth = 0;
  public invoicePeriods = [];
  public createdAt = new Date();
  public currentExtensionYear = 0;
  public currentExtensionPeriod = '';
  public extensionData = {} as VExtensionData;
  public deviceList = [] as VExtensionDevice[];
}
